import { Typography } from '@occc/ui-design-system';
import { displayAmount } from '@occc-app/lib/currency';

type MembershipActivityTransactionAmountProps = {
  amount: number;
};

/**
 * Component to display a activity dollar amount in the table
 */
export const MembershipActivityTransactionAmount = ({
  amount,
}: MembershipActivityTransactionAmountProps) => {
  return (
    <Typography component='span' variant='body2'>
      {displayAmount(amount, false)}
    </Typography>
  );
};
